/**
 * Route tree owned by the service-status module. The app router composes
 * this tree alongside other modules' trees in `app/router/routes.ts` — it
 * never defines service-status's child routes itself.
 */
import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import { rootRoute } from '../../app/router/rootRoute';
import { serviceStatusDashboardSchema } from './schemas/serviceStatusDashboard.schema';

const ServiceStatusDashboard = lazy(() =>
  import('./pages/ServiceStatusDashboard').then((module) => ({
    default: module.ServiceStatusDashboard,
  })),
);

const serviceStatusIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'services',
  validateSearch: serviceStatusDashboardSchema,
  component: ServiceStatusDashboard,
});

export const serviceStatusRouteTree = serviceStatusIndexRoute;
